export enum ProcessingFeeBasis {
  PerReturn = "per_return",
  PerItem = "per_item",
}
